import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import omit from 'lodash/omit';
import { defineMessages, FormattedMessage } from 'react-intl';
import { DialogContentText } from '@material-ui/core';

import * as actions from '../../../state';
import { AutoComplete } from '../../common';

const messages = defineMessages({
  SHARE_WITH_SPECIFIC: {
    id: 'SHARE_WITH_SPECIFIC',
    defaultMessage: 'Share with specific groups or people',
  },
  FILTER_SHARE_OPTIONS: {
    id: 'FILTER_SHARE_OPTIONS',
    defaultMessage: 'Select...',
  },
});

function ShareDialogAccessControl() {
  const board = useSelector(actions.readStateBoard);
  const choices = useSelector(actions.readStateAutocompleteChoices);

  const [value, setValue] = useState(0);

  const handleAutocomplete = (selectedOptions) => {
    board.share_details = selectedOptions;
    setValue(value + 1); // force update
  };

  const shareChoices = omit(choices, ['callqueue']);

  return (
    <>
      <DialogContentText>
        <FormattedMessage {...messages.SHARE_WITH_SPECIFIC} />
      </DialogContentText>

      <div style={{ margin: '12px 0' }}>
        <AutoComplete
          isGroupedOptions
          isMulti
          showAccessControls
          options={shareChoices}
          selectedOptions={board.share_details}
          handleAutocomplete={handleAutocomplete}
          placeholder={<FormattedMessage {...messages.FILTER_SHARE_OPTIONS} />}
        />
      </div>
    </>
  );
}

export default ShareDialogAccessControl;
